import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useQuery } from 'urql';
import { memo, useState } from 'react';
import { getCategories } from './queries';
import { CONTACT_URL, ERROR_MESSAGE, ROOT_URL } from './constants';
import CategoryLoader from './Category';
import ContactUs from './ContactUs';
import css from './index.module.scss';
import Nav from './Nav';
import QuickActionsAndContact from './QuickActionsAndContact';
import Search from './Search';
import SearchResults from './SearchResults';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var HelpCenter = function HelpCenter() {
  var params = new URLSearchParams(window.location.search);

  var _useQuery = useQuery({
    query: getCategories
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error;

  var _useState = useState(params.get('q')),
      _useState2 = _slicedToArray(_useState, 2),
      term = _useState2[0],
      setTerm = _useState2[1];

  var onSearch = function onSearch(newTerm) {
    setTerm(newTerm);
  };

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: ERROR_MESSAGE
    });
  }

  var categories = !fetching && data ? data.faqsCategories : [];
  return /*#__PURE__*/_jsxs(Router, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.header,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: "Help Center"
      }), /*#__PURE__*/_jsx(Search, {
        onSearch: onSearch
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.wrap,
      children: [/*#__PURE__*/_jsx(Nav, {
        categories: categories,
        fetching: fetching
      }), /*#__PURE__*/_jsx("div", {
        className: css.content,
        children: /*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(Route, {
            path: ROOT_URL,
            children: /*#__PURE__*/_jsx(QuickActionsAndContact, {
              categories: categories
            })
          }), /*#__PURE__*/_jsx(Route, {
            path: "".concat(ROOT_URL, "-search"),
            children: /*#__PURE__*/_jsx(SearchResults, {
              term: term
            })
          }), !fetching && data && categories.map(function (_ref) {
            var id = _ref.id,
                slug = _ref.slug,
                title = _ref.title;
            return /*#__PURE__*/_jsx(Route, {
              path: "".concat(ROOT_URL, "-").concat(slug),
              children: /*#__PURE__*/_jsx(CategoryLoader, {
                id: id,
                title: title
              })
            }, id);
          }), /*#__PURE__*/_jsx(Route, {
            path: CONTACT_URL,
            children: /*#__PURE__*/_jsx(ContactUs, {
              categories: categories
            })
          })]
        })
      })]
    })]
  });
};

export default /*#__PURE__*/memo(HelpCenter);